import { render, staticRenderFns } from "./study-course-detail.vue?vue&type=template&id=cb0fcd10&scoped=true&"
import script from "./study-course-detail.vue?vue&type=script&lang=js&"
export * from "./study-course-detail.vue?vue&type=script&lang=js&"
import style0 from "./study-course-detail.vue?vue&type=style&index=0&id=cb0fcd10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0fcd10",
  null
  
)

export default component.exports